.wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
}

.option {
    appearance: none;
    border: 0;
    min-width: 0;
    cursor: pointer;
    padding: 6px 10px;
    font: inherit;
    font-size: 16px;
    line-height: normal;
    text-align: inherit;
    border-radius: 4px;
    background: var(--ui-bg-color);
    background-image: none;
    color: rgba(0, 0, 0, 0.75);
    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.3);
    user-select: none;
    -webkit-user-select: none;

    &:not([aria-checked='true']) {
        &:hover {
            background: #eee;
        }

        &:active {
            box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.3);
        }
    }

    &:focus-visible {
        outline: 2px solid var(--active-highlight-color);
        outline-offset: 2px;
    }

    &[aria-checked='true'],
    &[aria-checked='true']:hover,
    &[aria-checked='true']:active {
        background: #fff;
        color: #000;
        box-shadow: inset 0 0 0 2px var(--active-highlight-color);
        cursor: default;
    }
}

.small {
    font-size: 14px;
}

.customEl {
    padding: 0;

    &:not([aria-checked='true']) > * {
        opacity: 0.75;
    }
}

:global(:root.kl-theme-dark) {
    .option {
        background: var(--ui-bg-dark);
        color: #ccc;
        box-shadow: inset 0 0 0 1px #606060;

        &:not([aria-checked='true']) {
            &:hover {
                background: #444;
            }

            &:active {
                box-shadow: inset 0 0 0 2px #666;
            }
        }

        &[aria-checked='true'],
        &[aria-checked='true']:hover,
        &[aria-checked='true']:active {
            background: #606060;
            color: #fff;
            box-shadow: inset 0 0 0 2px var(--active-highlight-color);
        }
    }
    .customEl {
        &:not([aria-checked='true']) > * {
            opacity: 0.6;
        }
    }
}
